<template>
  <v-container id="master-info-bencana" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="6">
        <base-material-card color="#018C74" icon="mdi-alert-octagon" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">INPUT INFO BENCANA</div>
            <div class="subtitle-2 secondary-text">Data Periode & Detail Bencana</div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.periode"
                  label="Periode (Contoh: Januari 2026)"
                  outlined
                  dense
                  color="#018C74"
                  prepend-inner-icon="mdi-calendar-range"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.deskripsi"
                  label="Deskripsi Bencana"
                  outlined
                  dense
                  rows="4"
                  color="#018C74"
                  prepend-inner-icon="mdi-text-subject"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  label="Unggah Foto Bencana"
                  outlined
                  dense
                  color="#018C74"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  @change="onFileChange"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-switch
                  v-model="editedItem.is_active"
                  :label="`STATUS: ${editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'}`"
                  :true-value="1"
                  :false-value="0"
                  color="#018C74"
                  inset
                  dense
                  class="mt-2 ml-1"
                ></v-switch>
              </v-col>
            </v-row>
            <v-card-actions class="px-0 pt-4">
              <v-spacer></v-spacer>
              <v-btn text color="rgba(255,255,255,0.6)" @click="clearForm"
                >BATALKAN</v-btn
              >
              <v-btn
                color="#CFA22D"
                class="cyber-save-btn"
                :loading="loading"
                @click="save"
              >
                <v-icon left>mdi-database-check</v-icon> SIMPAN DATA
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="6">
        <base-material-card color="#018C74" icon="mdi-table-large" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">ARSIP BENCANA</div>
          </template>

          <v-data-table
            :headers="headers"
            :items="listBencana"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.is_active="{ item }">
              <v-chip
                x-small
                :color="item.is_active == 1 ? '#018C74' : '#CFA22D'"
                label
                outlined
              >
                {{ item.is_active == 1 ? "AKTIF" : "OFF" }}
              </v-chip>
            </template>

            <template v-slot:item.foto="{ item }">
              <div class="table-img-frame">
                <v-img
                  v-if="item.foto"
                  :src="`https://berkah.bondowosokab.go.id:5500/uploads/${item.foto}`"
                  width="50"
                  height="40"
                  cover
                  class="rounded shadow-glow"
                />
                <v-icon v-else small>mdi-image-off-outline</v-icon>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)">
                <v-icon small>mdi-pencil-box-outline</v-icon>
              </v-btn>
              <v-btn icon color="#ff5252" @click="deleteItem(item)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    loading: false,
    listBencana: [],
    headers: [
      { text: "PERIODE", value: "periode" },
      { text: "STATUS", value: "is_active", align: "center" },
      { text: "FOTO", value: "foto", sortable: false },
      { text: "AKSI", value: "actions", align: "end", sortable: false },
    ],
    editedItem: { id: null, periode: "", deskripsi: "", foto_file: null, is_active: 1 },
    defaultItem: { id: null, periode: "", deskripsi: "", foto_file: null, is_active: 1 },
  }),

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/info-bencana`);

        if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
          this.listBencana = res.data.response.data;
        } else {
          this.listBencana = [];
          console.warn("Struktur data tidak sesuai yang diharapkan:", res.data);
        }
      } catch (e) {
        console.error("Error:", e);
        this.listBencana = [];
      } finally {
        this.loading = false;
      }
    },
    onFileChange(file) {
      this.editedItem.foto_file = file;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
    },
    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    async save() {
      this.loading = true;
      const formData = new FormData();
      Object.keys(this.editedItem).forEach((key) => {
        if (key !== "foto_file" && this.editedItem[key] !== null)
          formData.append(key, this.editedItem[key]);
      });
      if (this.editedItem.foto_file) formData.append("foto", this.editedItem.foto_file);

      try {
        if (this.editedItem.id)
          await axios.put(`${BASE_URL}/info-bencana/${this.editedItem.id}`, formData);
        else await axios.post(`${BASE_URL}/info-bencana`, formData);
        await this.fetchData();
        this.clearForm();
      } catch (e) {
        alert("Gagal menyimpan data");
      } finally {
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (confirm(`Hapus data periode ${item.periode}?`)) {
        try {
          await axios.delete(`${BASE_URL}/info-bencana/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal hapus");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-text {
  letter-spacing: 2px;
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}
.glass-card {
  background: rgba(0, 26, 22, 0.9) !important;
  backdrop-filter: blur(10px);
}
.cyber-save-btn {
  color: #000 !important;
  font-weight: 900;
}
.cyber-table {
  background: transparent !important;
}
.shadow-glow {
  box-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
